import AppRecord from './AppRecord.js'

class DepositBalance extends AppRecord {
  get deposit(){
    if (this.cachedDeposit == null) {
      this.cachedDeposit = this.constructor.employeeStore.deposits.find(deposit => deposit.id === Number(this.deposit_id))
    }

    return this.cachedDeposit
  }

  get issue(){
    if (this.cachedIssue == null) {
      if (this.issue_id !== null) {
        this.cachedIssue = this.constructor.employeeStore.issues.find(issue => issue.id === this.issue_id)
      } else if (this.isin !== null) {
        this.cachedIssue = this.constructor.employeeStore.issues.find(issue => issue.isin === this.isin)
      }
    }
    return this.cachedIssue
  }

  get bankName(){
    if (this.cachedBankName == null) {
      this.cachedBankName = this.constructor.employeeStore.banks.find(bank => bank.id === this.bank_id)?.name
    }

    return this.cachedBankName
  }
}
export default DepositBalance
